module.exports = __webpack_public_path__ + "img/swipe-img3.c2263a87.png";